import React, { PropsWithChildren } from 'react'
import { AssessRequirementsWorkflow } from './AssessmentWorkflow/AssessmentWorkflow'
import { EditShiftWorkFlow } from './EditShiftWorkFlow'
import { GlobalWorkflowsProvider } from './GlobalWorkflowManager/GlobalWorkflowManager'

export const GlobalWorkflows = ({ children }: PropsWithChildren) => {
  return (
    <GlobalWorkflowsProvider>
      <EditShiftWorkFlow />
      <AssessRequirementsWorkflow />
      {children}
    </GlobalWorkflowsProvider>
  )
}
